import React, { Component } from 'react';
import PromoCode from './promo_code/promo_code';
import { trackPromoCodeCheckout } from '../tracking/event';
import InlineCheckout from './InlineCheckout';
import Total from './Total';

const callToAction = (promoCode, discount, localisations) =>
  promoCode
    ? localisations.promo_code_accepted
    : `${discount}% ${localisations.early_renewal_applied}`;

const promoCodeView = (props, visible, togglePromoCodeForm, errorVisible) => {
  if (props.context.discounts_available) {
    if (!props.discounts.percentage) {
      return (
        <PromoCode
          togglePromoCodeForm={togglePromoCodeForm}
          promoFormVisible={visible}
          errorVisible={errorVisible}
          {...props}
        />
      );
    }

    if (Number(props.checkoutTotal) < Number(props.currentProduct.price)) {
      return (
        <div>
          <div className="message-box message-box--success">
            <span className="message-box__icon">
              <i className="far fa-check-circle" />
            </span>
            <p className="message-box__text">
              {callToAction(
                props.discounts.promo_code,
                props.discounts.percentage,
                props.localisations,
              )}
            </p>
          </div>
          {props.userType == 'seeker' ? (
            <Total
              discounts={props.discounts}
              subTotal={props.checkoutSubTotal}
              total={props.checkoutTotal}
              currencySymbol={props.staticData.site.currency_symbol}
              localisations={props.localisations}
            />
          ) : null}
        </div>
      );
    }
  }
  return null;
};

class CheckoutView extends Component {
  constructor(props) {
    super(props);
    this.togglePromoCodeForm = this.togglePromoCodeForm.bind(this);
    this.state = {
      promoFormVisible: !!this.props.discounts.error,
      subTotal: 0,
    };
    this.errorVisible = !!this.props.discounts.error;
  }

  togglePromoCodeForm() {
    if (!this.state.promoFormVisible) {
      trackPromoCodeCheckout({
        label: `${this.props.staticData.site.base_url}${this.props.staticData.site.loginReturnPath}|${this.props.currentProduct.price}|${this.props.currentProduct.duration}`,
      });
    }
    this.setState({
      // If the user previously entered an invalid promo code, an error flash
      // message should display and the promo form should be open by default.
      promoFormVisible: !this.state.promoFormVisible,
    });
  }

  render() {
    return (
      <section className="checkout">
        {promoCodeView(
          this.props,
          this.state.promoFormVisible,
          this.togglePromoCodeForm,
          this.errorVisible,
        )}
        {this.props.userType == 'offerer' ? (
          <Total
            discounts={this.props.discounts}
            subTotal={this.props.checkoutSubTotal}
            total={this.props.checkoutTotal}
            currencySymbol={this.props.staticData.site.currency_symbol}
            localisations={this.props.localisations}
          />
        ) : null}
        <InlineCheckout
          affiliateId={this.props.staticData.affiliate.id}
          baseUrl={this.props.staticData.site.base_url}
          beforeSubmitErrorCheck={this.props.beforeSubmitErrorCheck}
          callback={this.props.storeOrderDetails}
          checkoutSubTotal={this.props.checkoutSubTotal}
          checkoutTotal={this.props.checkoutTotal}
          context={this.props.staticData.miscellaneous.context}
          currency_symbol={this.props.staticData.site.currency_symbol}
          currency={this.props.staticData.site.currency}
          currentProductId={this.props.currentProduct.id}
          discounts={this.props.discounts}
          extraListings={{
            total: this.props.extraListingsTotal,
            count: this.props.extraListingsCount,
            id: this.props.extraListingsSelectedId,
          }}
          experiments={this.props.experiments}
          paymentProviders={this.props.paymentProviders}
          paymentReturnUrls={this.props.stripeUrls}
          paymentSuccessCallback={this.props.paymentSuccessCallback}
          platform={this.props.context.platform}
          siteId={this.props.staticData.site.id}
          staticFilesServer={this.props.staticData.site.static_files_server}
          stripeButtonText={this.props.localisations.upgrade_now}
          upgradeContext={this.props.context.context}
          userId={this.props.staticData.customer.id}
          localisations={this.props.localisations}
          walletButtons={this.props.walletButtons}
        />
      </section>
    );
  }
}

export default CheckoutView;
